import {
  Component,
  ElementRef,
  Renderer2,
  RendererStyleFlags2,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {
  IonicPage,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import { VerbalCertificationForm } from "../verbal-certification-form/verbal-certification-form";
import { WrittenCertificationForm } from "../written-certification-form/written-certification-form";

@IonicPage()
@Component({
  selector: "page-received-certification-v2",
  templateUrl: "certification-received-v2.html",
})
export class CertificationReceivedModalV2 {
  @ViewChild(VerbalCertificationForm) verbalCert: VerbalCertificationForm;
  @ViewChild(WrittenCertificationForm) writtenCert: WrittenCertificationForm;
  certificationForm: FormGroup;
  isValidForm: boolean = false;

  embedded = false;
  addNewData: boolean = false;

  certTypeControl: FormControl;
  createVerbalEnabled = false;
  createWrittenEnabled = false;
  disabledBtn = false;
  patientStatus: string;
  writtenCertifications: number = 0;
  verbalCertifications: number = 0;
  origin: string;
  type: string;
  isOnService: boolean;
  width: number;

  defaultNarrative: string;
  editData = {};
  source: string = "";
  editId: number = 0;
  verbalCertificationAccess: number = 0;

  allowNarrativeEdit: boolean = false;
  validateCertifyingPhysician: boolean = false;
  validateAttendingPhysician: boolean = false;
  loggedInUserIsMDorDO: boolean = false;
  verbalCertificationBenefitsIds: number[] = [];
  constructor(
    private viewCtrl: ViewController,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private toastCtrl: ToastController,
    private navParams: NavParams
  ) {
    let navData = navParams.data;
    this.embedded = navData.embedded || false;
    this.addNewData = navData.addNewData || false;
    this.width = navData.width || 700;

    this.patientStatus = navData.patientStatus;
    this.writtenCertifications = navData.certificateData.writtenCertifications;
    this.verbalCertifications = navData.certificateData.verbalCertifications;
    this.createVerbalEnabled = navData.createVerbalEnabled;
    this.createWrittenEnabled = navData.createWrittenEnabled;
    this.loggedInUserIsMDorDO = navData.loggedInUserIsMDorDO;
    this.verbalCertificationBenefitsIds =
      navData.verbalCertificationBenefitsIds;

    if (navData.certificateData.data) {
      this.editData = navData.certificateData.data;
      this.source = navData.certificateData.source;
      this.editId = navData.certificateData.data.id;
    }

    if (navData.certificateData.data) {
      if (this.loggedInUserIsMDorDO) {
        this.validateCertifyingPhysician = true;
        this.validateAttendingPhysician = true;
        this.allowNarrativeEdit = true;
      }
    } else {
      if (this.loggedInUserIsMDorDO) {
        this.validateCertifyingPhysician = true;
        this.validateAttendingPhysician = true;
        this.allowNarrativeEdit = true;
      }
    }

    const isOnService =
      !!this.patientStatus &&
      this.patientStatus.toLowerCase() !== "referral" &&
      !this.embedded;
    this.origin = isOnService ? "PATIENT_CHART" : "REFERRAL";
    this.isOnService = isOnService;

    // Default narrative statemenet
    this.defaultNarrative = navData.defaultNarrative;

    this.certTypeControl = new FormControl("");

    this.certTypeControl.valueChanges.subscribe((_x) => {
      this.setIsValidForm(false);
    });

    if (this.embedded && navData.addNewData) {
      this.certTypeControl.setValue("VERBAL");
    } else {
      if (this.source == "verbal") {
        this.certTypeControl.setValue("VERBAL");
      } else if (this.source == "written") {
        this.certTypeControl.setValue("WRITTEN");
      }
    }
  }

  ngOnInit() {
    const modalContent = this.elRef.nativeElement.parentNode;
    this.renderer.addClass(modalContent, "modal-cti-confirmation");

    if (this.embedded) {
      this.renderer.addClass(modalContent.parentNode, "embedded-modal");
      this.renderer.setStyle(
        modalContent.parentNode,
        "width",
        `${this.width + 35}px`,
        RendererStyleFlags2.Important
      );
      console.log("Preferred width: ", this.width, "---------------");
    }
  }

  onSubmit() {
    this.disabledBtn = true;

    if (this.certTypeControl.value === "VERBAL") {
      this.verbalCert.onSubmit().then(this.onDismiss);
    } else if (this.certTypeControl.value === "WRITTEN") {
      this.writtenCert.onSubmit().then(this.onDismiss);
    }
  }

  setIsValidForm(valid: boolean) {
    this.isValidForm = valid;
  }

  checkWrittenAccess() {
    return this.createWrittenEnabled
      ? this.createWrittenEnabled
      : this.loggedInUserIsMDorDO;
  }

  onCancel = () => {
    this.viewCtrl.dismiss({ cancel: true }, null, { animate: !this.embedded });
    this.disabledBtn = false;
  };

  onDismiss = (res) => {
    if (res.error == null) {
      this.viewCtrl.dismiss(
        {
          updated: true,
          cancel: false,
        },
        null,
        { animate: !this.embedded }
      );
    } else {
      this.presentToast(res.error);
    }
    this.disabledBtn = false;
  };

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/certification/forms/certification-received-v2/certification-received-v2.ts